import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { InferRequestType, InferResponseType } from 'hono/client'

import { apiClient, formatClientResponse } from '@/apiClient.ts'

type UpdateAttributeGroupByIdRequest = InferRequestType<
  (typeof apiClient)['attribute-groups'][':attributeGroupId']['$patch']
>['json']
type UpdateAttributeGroupByIdResponse = InferResponseType<
  (typeof apiClient)['attribute-groups'][':attributeGroupId']['$patch']
>

export type UseUpdateAttributeGroupByIdArgs = {
  attributeGroupId: string
  data: UpdateAttributeGroupByIdRequest
}

export const useUpdateAttributeGroupById = (
  options?: UseMutationOptions<
    UpdateAttributeGroupByIdResponse,
    Error,
    UseUpdateAttributeGroupByIdArgs
  >
) =>
  useMutation({
    mutationFn: async (variables) => {
      return await apiClient['attribute-groups'][':attributeGroupId']
        .$patch({
          param: { attributeGroupId: variables.attributeGroupId },
          json: variables.data,
        })
        .then((r) => formatClientResponse(r))
    },
    mutationKey: ['attribute-group-update'],
    ...options,
  })
